<template>
    <div>
        <div v-for="(paymentMethod, index) in data" class="media payment-method">
            <a @click.prevent="toggleDisplay('subs', index)" class="open"></a>
            <div class="media-left payment-method__logo">
                <img :src="paymentMethod.imageUrl" />
            </div>
            <div class="media-body payment-method__label">
                <small>{{ paymentMethod.cardType }}</small>
                <span class="badge" v-html="paymentMethod.noSubs"></span>
                <span v-if="paymentMethod.default" class="label label-default">{{ trans('Default') }}</span>
                <label class="card-number">{{ paymentMethod.maskedNumber }}</label>
                <!--<a @click.prevent="deleteMethod(paymentMethod.token)" class="btn btn-primary"><i class="icon icon-trash"></i></a>-->
                <div v-show="isVisible('subs', index)" class="billing-open">

                    <span class="subscriptions">Subscriptions: <span class="badge" v-html="paymentMethod.noSubs"></span></span>
                    <a @click.prevent="toggleDisplay('edit', index)" class="btn btn-primary"><i class="icon icon-edit"></i> Reassign all</a>
                    <div v-if="isVisible('edit', index)">
                        <h3>Reassign all subscriptions in this payment method</h3>
                        <subscription v-model="paymentMethod.data" :token="token"></subscription>
                        <div v-if="paymentMethod.errorMessage">{{ paymentMethod.errorMessage }}</div>
                        <button class="btn btn-success" @click.prevent="updateMethod(paymentMethod)"><i class="icon icon-save"></i> Update</button>
                    </div>
                    <div class="row" v-for="sub in paymentMethod.subscriptions">
                        <hr>

                        <div class="col-md-6">
                            <div>
                                <label>Subscription ID:</label> <span v-html="sub.id"></span>

                                <!-- Active / Cancelled status -->
                                <span v-if="sub.status === 'Active'" class="label label-success">{{ trans('Active') }}</span>
                                <span class="label label-danger" v-else>{{ trans('Cancelled') }}</span>
                            </div>
                            <div>
                                <label>Plan ID:</label> <span>{{ sub.planId }}</span>
                            </div>
                            <div v-if="sub.entity">
                                <label>Name:</label> <span>{{ sub.entity.name }}</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div>
                                <label>Next Billing Day:</label> <span v-html="sub.nextBillingDate"></span>
                            </div>
                            <div>
                                <label>Cost:</label> <span v-html="sub.price"></span>
                            </div>
                            <div>
                                <label>Created On:</label> <span v-html="sub.createdAt"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="media-right payment-method__action">
                <a @click.prevent="toggleDisplay('subs', index)">
                    <i v-if="isVisible('subs', index)" class="icon icon-up"></i>
                    <i class="icon icon-down" v-else></i>
                    <a @click.prevent="deleteMethod(paymentMethod.token)" class="delete"><i class="icon icon-cancel"></i></a>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data: function() {
            return {
                disableComment: false,
                paymentData: false,
                model: {},
                display: {
                    subs: [],
                    edit: []
                }
            }
        },
        props: {
            name: { default: '' },
            data: { default : [] },
            token: { default: '' }
        },
        created() {
        },
        methods: {
            deleteMethod(token) {
                this.$store('/api/settings/subscriptions/delete', {
                    token: token
                });
            },
            updateMethod(method) {
                this.model = {};
                method.data.requestPaymentMethod((dropinPayloadErr, dropinPayload) => {
                    if (dropinPayloadErr) {
                        method.errorMessage = 'There was an error with Drop-In Payload! Message: ' + dropinPayloadErr.message;
                        return;
                    }
//                    this.dropinPayload = dropinPayload;
                    this.model.subscriptions = method.subscriptions;
                    this.model.nonce = dropinPayload.nonce;
                    this.$store('/api/settings/subscriptions/update', this);
                });
            },
            toggleDisplay(type, index) {
                Vue.set(this.display[type], index, !this.isVisible(type, index))
            },
            isVisible(type, index) {
                return (typeof this.display[type][index] !== 'undefined' && this.display[type][index]);
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy: function () {
//                this.$eventHub.$off('set' + this.name + 'User', this.setUser);
        },
        components: {
            'subscription': require('../subscription/payment.vue').default
        }
    }
</script>
